import React, { useState } from 'react'
import { Drawer, Alert, Message, Button } from '@arco-design/web-react'
import { IconSettings } from '@arco-design/web-react/icon'
import copy from 'copy-to-clipboard'
import { useSelector } from 'react-redux'
import Block from './block'
import ColorPanel from './color'
import useLocale from '@/hooks/useLocale'
import IconButton from '../NavBar/IconButton'

interface SettingProps {
  trigger?: React.ReactElement<any>
}

function Setting(props: SettingProps) {
  const { trigger } = props
  const [visible, setVisible] = useState(false)
  const locale = useLocale()
  const settings = useSelector((state) => state['app'].settings)

  function onCopySettings() {
    copy(JSON.stringify(settings, null, 2))
    Message.success(locale['settings.copySettings.message'])
  }

  return (
    <>
      {trigger ? (
        React.cloneElement(trigger, {
          onClick: () => setVisible(true),
        })
      ) : (
        <IconButton icon={<IconSettings />} onClick={() => setVisible(true)} />
      )}
      <Drawer
        width={300}
        title={
          <div style={{display:'flex',alignItems:'center'}}>
            <IconSettings />
            {locale['settings.title']}
          </div>
        }
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={
          <div
            style={{
              display: 'flex',
              justifyContent: 'right',
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                setVisible(false)
              }}
              tabIndex={1}
            >
              {locale['settings.close']}
            </Button>
          </div>
        }
      >
        {/* <Block title={locale['settings.themeColor']}>
          <ColorPanel />
        </Block> */}
        <Block
          title={locale['settings.content']}
          options={[
            { name: 'settings.navbar', value: 'navbar' },
            { name: 'settings.menu', value: 'menu' },
            { name: 'settings.footer', value: 'footer' }, //底部
            { name: 'settings.popUpMenu', value: 'popUpMenu' },
            {
              name: 'settings.popUpMenuType',
              value: 'popUpMenuType',
              type: 'select',
              options: [
                { value: 1, label: locale['settings.popUpMenuType.button'] },
                { value: 2, label: locale['settings.popUpMenuType.menu'] },
              ],
            },
            // {
            //   name: 'settings.tableHeightControl',
            //   value: 'tableHeightControl',
            // },
            // { name: 'settings.formShowTab', value: 'formShowTab' }, //表单Tab模式
            {
              name: 'settings.tableSize',
              value: 'tableSize',
              type: 'select',
              options: [
                { value: 'default', label: 'default' },
                { value: 'middle', label: 'middle' },
                { value: 'small', label: 'small' },
                { value: 'mini', label: 'mini' },
              ],
            },
            { name: 'settings.menuWidth', value: 'menuWidth', type: 'number' },
            //'default' | 'middle' | 'small' | 'mini'
          ]}
        />
        <Block
          title={locale['settings.otherSettings']}
          options={[{ name: 'settings.colorWeek', value: 'colorWeek' }]}
        />
      </Drawer>
    </>
  )
}

export default Setting

